import { render, staticRenderFns } from "./time-span.vue?vue&type=template&id=3763441c&"
import script from "./time-span.vue?vue&type=script&lang=js&"
export * from "./time-span.vue?vue&type=script&lang=js&"
import style0 from "./time-span.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports